export default __webpack_public_path__ + "static/media/element_20.8a634af5.webp";